<template>
    <Collapse :multiple-active="false">
        <Spinner mini v-if="loading" />
        <CollapseItem
            v-else
            class="my-3"
            v-for="node in content.data"
            :id="node.id"
            :locked="node.type !== 'Module'"
            :key="`course-${node.type}-${node.id}`"
            @onSelect="handleOpenContent(node, $event)"
        >
            <template #title><h4 class="text-muted d-flex align-items-center mb-0">
                <span class="pr-3 mdi" :class="contentIcon(node.type)"></span>
                {{nameHandler(node)}}
                <span
                    v-if="node.public"
                    class="ml-auto badge badge-success"
                    @click="redirectToPublicLesson(node.id)"
                >
                    {{ $t('content.lesson.watch_now') }}
                </span>
            </h4></template>
            <PlanDetailsModuleContent
                v-if="node.id === moduleId"
                :planId="planId"
                :courseId="id"
                :moduleId="moduleId"
            />
        </CollapseItem>
        <div v-if="!loading">
            <base-pagination
                class="mb-0"
                v-if="content.meta.total > 10"
                :page-count="content.meta.last_page"
                v-model="content.meta.current_page"
                @input="onChangePage"
                align="center"
                type="#525F7F"
            ></base-pagination>
        </div>
    </Collapse>
</template>

<script>
import Collapse from '../../argon/components/Collapse/Collapse';
import CollapseItem from '../../argon/components/Collapse/CollapseItem';
import Spinner from '../../components/Common/LoadingSpinner';
import PlanDetailsModuleContent from './PlanDetailModuleContent';
import BasePagination from '../../argon/components/BasePagination';

import ContentIcons from '../../mixins/ContentIcon';

export default {
    name: 'PlanDetailsCourseCollapse',

    props: {
        planId: {
            type: Number,
            required: true,
        },
        id: Number,
    },

    mixins: [
        ContentIcons,
    ],

    components: {
        Collapse,
        CollapseItem,
        Spinner,
        PlanDetailsModuleContent,
        BasePagination,
    },

    data() {
        return {
            loading: false,
            moduleId: null,
            content: {
                data: [],
                meta: {},
                links: {},
            },
        };
    },

    watch: {
        id: {
            immediate: true,
            handler(value) {
                this.handleGetContent();
            },
        },
    },

    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
    },

    methods: {
        handleGetContent() {
            this.loading = true;
            return window.axios
                .get(
                    `/api/public/details/plan/${this.planId}/course/${this.id}/contents`,
                    {
                        params: {
                            page: this.content.meta.current_page
                                ? this.content.meta.current_page
                                : 1,
                            iso: localStorage.getItem('lang'),
                        },
                    },
                )
                .then((res) => {
                    this.content.data = res.data.data;
                    this.content.meta = res.data.meta;
                    this.content.links = res.data.links;
                })
                .catch((err) => {
                    this.$notify({
                        type: 'danger',
                        message: this.$t('common.response.error'),
                    });
                })
                .finally(() => (this.loading = false));
        },

        handleLock(nodeType) {
            if (this.locked) return true;
            if (nodeType === 'Course') return false;
            return true;
        },
        nameHandler(node) {
            if (node.type === 'Module') return node.translation;
            return node.translation.name;
        },
        handleOpenContent(node, event) {
            if (node.type === 'Module') {
                this.moduleId = event;
            }
        },
        onChangePage(page) {
            this.content.meta.current_page = page;
            this.handleGetContent();
        },
        async redirectToPublicLesson(id) {
            return window.axios
                .get(`/api/app/public/plan/${this.planId}/lesson/${id}/signed-url`)
                .then((res) => {
                    window.location.href = res.data.url;
                })
                .catch((err) => {
                    this.$notify({
                        type: 'danger',
                        message: this.$t('common.response.error'),
                    });
                })
                .finally(() => (this.loading = false));
        },
    },
};
</script>

<style>
</style>
